import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DashboardLayout } from "../DashboardLayout";
import { ExecButton } from "../../../ui/ExecButton/ExecButton";
import { INodeWithPath } from "../../../../interface/interfaces";
import { DashboardCard } from "../DashboardCard";
import { useTabButtons } from "../../../../hooks/useTabButtons";
import { DASHBOARD_CONFIG_BUTTONS } from "../../../../constants/constants";
import { SpacingCustom } from "../../../layout/Spacing/SpacingCustom";
import { Overview } from "./Overview/Overview";
import { Configuration } from "./Configuration/Configuration";
import { Files } from "./Files/Files";
import { Spacing } from "../../../layout/Spacing/Spacing";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { rootState } from "../../../../redux/store";
import { fetchNodeInfoPending } from "../../Tree/nodeInfo.slice";

export const DashboardConfigMain = () => {

    const navigate = useNavigate()
    const location = useLocation();
    const nodeId = new URLSearchParams(location.search).get('nodeId') as string;
    const dispatch = useAppDispatch();


    const {userAndTokenData} = useAppSelector((state:rootState)=>state.loginUserAndTokenData)
    const {project} = useAppSelector((state:rootState)=>state.project)

    const {tabButtons, activeBtn} = useTabButtons(DASHBOARD_CONFIG_BUTTONS, 1.8);

    const nodeData = location.state?.node as INodeWithPath;

    useEffect(() => {
        
        if (userAndTokenData && nodeId) {
            dispatch(
                fetchNodeInfoPending({
                    url: `project/${project?._id}/avatar-info/${nodeId}`,
                    token: userAndTokenData?.token,
                }),
            );
        }
    }, [userAndTokenData, project?._id, nodeId, dispatch]);




    return (
        <DashboardLayout minWidth={850} stretch>
                <div style={{position:'absolute', top:'.8rem', left:'.8rem'}}>
                    <ExecButton showLabel = {false} label={"Back"} iconName={"Back"} func={() => navigate(-1)}/>
                </div>
                <DashboardLayout hasDistance = {false} minWidth={850} paddingTop={0}>

                    <DashboardCard titleSize="l" leftDistance={0} iconSize={4} node={nodeData} showBtn = {false} showBg = {false} display="grid"/>
                </DashboardLayout>
                <DashboardLayout hasDistance = {false} minWidth={850} paddingTop={0}>
                    <Spacing paddingSpacing="l" marginSpacing="none">
                        <SpacingCustom paddingTop={2}>
                            {tabButtons}
                        </SpacingCustom>
                    </Spacing>
                </DashboardLayout>
                <SpacingCustom paddingLeft={1.2} paddingRight={1.2} paddingTop={0}>
                    <SpacingCustom paddingTop={2}>
                        {activeBtn === 'Overview' && <Overview/>}
                        {activeBtn === 'Configuration' && <Configuration/>}
                        {activeBtn === 'Files' && <Files/>}
                    </SpacingCustom>
                </SpacingCustom>
                {/* <h2>Details for Card {nodeId}</h2> */}
        </DashboardLayout>
    );
}   